import { defineComponent as _defineComponent } from 'vue'
import { computed, watch } from 'vue';
import { useFormElement } from '../../composables/useFormElement';
import { makeUseFormElementEmits, makeUseFormElementProps } from '../../composables/useFormElementInterfaces';
import { FieldModel } from '../../interfaces';
import { useBaseFieldValues } from '../../composables/useBaseFieldValues';
import { useTextFormFieldMethods } from '../../composables/useTextFormFieldMethods';
import InputGroupWrapper from '../common/InputGroupWrapper.vue';
import { extractIBAN, friendlyFormatIBAN, electronicFormatIBAN } from 'ibantools';


export default /*#__PURE__*/_defineComponent({
  __name: 'IBANFormField',
  props: makeUseFormElementProps<FieldModel, string>(),
  emits: makeUseFormElementEmits<string>(),
  setup(__props, { emit }) {

const props = __props;





const formElement = useFormElement<FieldModel, string>({
  emit,
  props,
});

const {
  dirtyOnInput,
  maxLength,
  inputName,
  fieldType,
  readonly,
  inputMode,
  autocomplete,
  placeholder,
  inputClass,
  inputErrorClass,
  fieldErrorsShown,
} = useBaseFieldValues(formElement);

const { onBlur, onKeyPress, onPaste } = useTextFormFieldMethods(formElement, { setValue });

const { model, field, setModelState, setValue: formElementSetValue } = formElement;

const stringVal = computed(() => {
  return friendlyFormatIBAN(field.value.$model) || field.value.$model;
});

function setValue(value: string) {
  const iban = extractIBAN(electronicFormatIBAN(value) ?? '');
  setModelState('validIBAN', iban.valid);
  formElementSetValue(iban.valid ? iban.iban : value, !field.value.$dirty && !dirtyOnInput.value);
}

watch(stringVal, () => {
  const iban = extractIBAN(electronicFormatIBAN(stringVal.value) ?? '');
  setModelState('validIBAN', iban.valid);
});

setValue(field.value.$model);

return { __sfc: true,props, emit, formElement, dirtyOnInput, maxLength, inputName, fieldType, readonly, inputMode, autocomplete, placeholder, inputClass, inputErrorClass, fieldErrorsShown, onBlur, onKeyPress, onPaste, model, field, setModelState, formElementSetValue, stringVal, setValue, InputGroupWrapper }
}

})